import { getDateTime, getFormattedSeconds } from "./utils";

type DurationProps = {
  seconds: number;
};

export default function Duration({ seconds }: DurationProps): React.ReactElement {
  return <time dateTime={getDateTime(seconds)}>{getFormattedSeconds(seconds)}</time>;
}
